import { render, staticRenderFns } from "./SQuesSeventeen.vue?vue&type=template&id=06d63c82&"
import script from "./SQuesSeventeen.vue?vue&type=script&lang=js&"
export * from "./SQuesSeventeen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports